/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsFeaturedCollection = {
    init: function ($section) {

      Shopify.theme.jsFeaturedCollection = $.extend(this, Shopify.theme.getSectionData($section));

      let $sliderEl = $section.find('[data-slider]');

      if (this.collection_style == 'slider') {
        this.createSlider($sliderEl, $section);
      }
    },

    createSlider: function ($sliderEl, $section) {

      const slideData = {
        products_per_slide: this.products_per,
        products_available: this.products_available,
        products_limit: this.products_limit,
      }

      const slider = $sliderEl.flickity({
        lazyLoad: 2,
        freeScroll: false,
        imagesLoaded: true,
        draggable: true,
        cellAlign: 'left',
        wrapAround: false,
        pageDots: false,
        contain: true,
        prevNextButtons: false,
        initialIndex: 0,        
        groupCells: 4,        
        arrowShape: arrowShape
      });

      slider.on('settle.flickity', function () {
        slider.flickity('resize');
      });

      // Custom buttons
      const $prevButton = $section.find('.custom-slider-prev');
      const $nextButton = $section.find('.custom-slider-next');

      $prevButton.on('click', function () {
        slider.flickity('previous');
      });

      $nextButton.on('click', function () {
        slider.flickity('next');
      });

      function updateButtons() {
        const flkty = slider.data('flickity');

        if (flkty) {
          $prevButton.prop('disabled', flkty.selectedIndex === 0);
          $nextButton.prop('disabled', flkty.selectedIndex === flkty.slides.length - 1);
        }
      }

      updateButtons();

      slider.on('select.flickity', function () {
        updateButtons();
      });
    },
    unload: function ($section) {
      let $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
    }
  }

  /******/
})()
  ;